'use strict';

if (!Symbol.species) {
    Symbol.species = Symbol.for('@@species');
}



//////////////////
// WEBPACK FOOTER
// ./~/ml-pca/~/ml-matrix/src/symbol-species.js
// module id = 278
// module chunks = 0